module.exports = {
  MAKE_ROW_HEIGHT: height => () => height
};
